import React from 'react';
import { useQuery } from 'react-query'; // React Query for async data fetching and caching
import { IOfferItem } from 'types/offers'; // Type for individual offer items
import { QUERY_KEYS } from '../../../../constants'; // Query keys used to cache and identify API data
import { activityStats } from 'api/user'; // API call function for completed earnings
import styles from './styles.module.scss'; // Scoped SCSS styles
import EarnCard from './earn-card'; // UI card for showing each earning item
import { ActivityStatsResponse } from 'types/user'; 

const InProgress: React.FC = () => {

  // Use React Query to fetch user activity stats (managed by the header component)
  const { data: stats, isLoading } = useQuery<ActivityStatsResponse>(
    [QUERY_KEYS.USER.ACTIVITY_STATS],
    activityStats,
    {
      enabled: false, // Only reads from cache, disable automatic refetching, rely on header component to manage refetching
    }
  );

  // Extract the active offers ("in progress") from the stats object
  const activeOffers: IOfferItem[] = stats?.active_offer_jsons || [];
  
  return (
    <div className={styles.wrapper}>
      {isLoading ? (
        // Show placeholder loading cards while data is being fetched for the 1st time
        [1, 2, 3].map((item, index: number) => {
          return <EarnCard loading={isLoading} data={null} key={index} />;
        })
      ) : activeOffers?.length && activeOffers.length > 0 ? (
        // If there is data, render cards
        activeOffers.map((item, index: number) => {
          return <EarnCard key={`item-${index}`} data={item} loading={isLoading} />;
        })
      ) : (
        // If no data, show msg
        <span style={{paddingLeft: 16, position: 'absolute'}}>
          No active offers...
        </span>
      )}
    </div>
  );
};

export default InProgress;
